import { useQuery } from '@tanstack/react-query';
import { getCommunityExpertiseGeneral, getEthnicities, getFaiths } from '@uplift/api';
import { SelectListsContained } from '@uplift/ui-v2';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { CommunityExpertise, Ethnicity, Faith } from '@uplift/types';

export type CommunityExpertiseFormProps = {
  hideLabel?: boolean;
};

export const CommunityExpertiseForm: React.VFC<CommunityExpertiseFormProps> = props => {
  const { data: ethnicities = [], isInitialLoading: ethnicitiesLoading } = useQuery(PROFILE_ROW_QUERY_KEYS.ethnicity, async () => {
    const response = await getEthnicities();

    return response.data;
  });

  const { data: faiths = [], isInitialLoading: faithsLoading } = useQuery(PROFILE_ROW_QUERY_KEYS.faith, async () => {
    const response = await getFaiths();

    return response.data;
  });

  const { data: communityExpertiseGeneral = [], isInitialLoading: communityExpertiseGeneralLoading } = useQuery({
    queryKey: [ 'community-expertise-general' ],
    queryFn: async () => {
      const response = await getCommunityExpertiseGeneral();

      return response.data;
    }
  });

  return (
    <div>
      <SelectListsContained
        label={props.hideLabel ? undefined : 'Select from Ethnicity and Race, Faith, and General communities (Optional)'}
        selectionOverviewText="communities selected"
        lists={[
          {
            label: 'Ethnicity and Race',
            options: ethnicities.sort((a, b) => a.name.localeCompare(b.name)),
            getOptionLabel: (option: Ethnicity) => option.name,
            name: 'ethnicities',
            loading: ethnicitiesLoading
          },
          {
            label: 'Faith',
            options: faiths.sort((a, b) => a.name.localeCompare(b.name)),
            getOptionLabel: (option: Faith) => option.name,
            name: 'faiths',
            loading: faithsLoading
          },
          {
            label: 'General',
            options: communityExpertiseGeneral.sort((a, b) => a.name.localeCompare(b.name)),
            getOptionLabel: (option: CommunityExpertise) => option.name,
            name: 'general',
            loading: communityExpertiseGeneralLoading
          }
        ]}
      />
    </div>
  );
};
